<template>
  <div ref="languageButton" class="language">
    <UiButton
      class="language__button"
      size="small"
      text
      @click="isOpen = !isOpen"
    >
      <template #prepend-icon>
        <div class="language__icon">
          <img :src="activeLanguage.icon" :alt="activeLanguage.value" />
        </div>
      </template>
      {{ activeLanguage.shortLabel }}
    </UiButton>
    <Transition name="fade">
      <div v-show="isOpen" class="language__dropdown">
        <UiButton
          v-for="language in languageList"
          :key="language.value"
          text
          size="small"
          color="secondary"
          class="language__dropdown-button"
          style="padding: 8px !important"
          @click="changeLanguage(language)"
        >
          <div class="language__dropdown-icon">
            <img :src="language.icon" :alt="language.value" />
          </div>
          <div
            class="language__dropdown-label"
            :class="{ arm: language.value === 'hy' }"
          >
            {{ language.label }}
          </div>
          <div
            v-if="activeLanguage.value === language.value"
            class="language__dropdown-check"
          >
            <svgo-check />
          </div>
        </UiButton>
      </div>
    </Transition>
  </div>
</template>

<script setup async>
import useLanguageStore from '~/store/language';
import { onClickOutside } from '@vueuse/core';

import { STORAGE_LANGUAGE_KEY, MAX_AGE } from '~/constants/cookieStorage';

const { $switchLocale } = useI18n();
const languageStore = useLanguageStore();
const languageList = languageStore.languageList;

const isOpen = ref(false);
const activeLanguage = computed(() => languageStore.activeLanguage);

const languageButton = useTemplateRef('languageButton');
onClickOutside(languageButton, () => (isOpen.value = false));

function changeLanguage(language) {
  languageStore.setLanguage(language.value);
  $switchLocale(language.value);
  setCookieLanguage(language.value);
  setBodyClassFromLanguage(language.value);
  document.querySelector('html').setAttribute('lang', language.value);

  isOpen.value = false;
}

function setCookieLanguage(language) {
  useCookie(STORAGE_LANGUAGE_KEY, {
    maxAge: MAX_AGE,
  }).value = language;
}

function setBodyClassFromLanguage(language) {
  if (language === 'hy') {
    document.body.classList.add('arm');
  } else {
    document.body.classList.remove('arm');
  }
}
</script>

<style lang="scss">
@use '@styles/components/language.scss' as *;
</style>
